(function() {
  // Global Lazy Section Loader for Template-based Lazy Loading
  // Author: Antigravity
  // This script manages all sections wrapped in .lazy-section-wrapper to reduce Initial Load TBT.

  document.addEventListener("DOMContentLoaded", function() {
    var lazyWrappers = document.querySelectorAll('.lazy-section-wrapper');
    
    if (lazyWrappers.length === 0) return;

    var observerOptions = {
      root: null,
      rootMargin: '400px', // Large margin to ensure content is ready before user sees it
      threshold: 0
    };

    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var wrapper = entry.target;
          var template = wrapper.querySelector('template');
          
          if (template) {
            // 1. Clone content
            var content = template.content.cloneNode(true);
            
            // 2. Inject content
            wrapper.appendChild(content);
            
            // 3. Cleanup logic (remove template to free memory)
            // We delay removal slightly to ensure browser processes the new DOM
            requestAnimationFrame(function() {
              template.remove();
              wrapper.classList.add('loaded'); // Optional: for styling hooks
            });

            // Debug log
            var sectionName = wrapper.dataset.sectionId || 'unknown';
            console.log("Lazy Loaded via Template: " + sectionName);
          }
          
          observer.unobserve(wrapper);
        }
      });
    }, observerOptions);

    lazyWrappers.forEach(function(wrapper) {
      observer.observe(wrapper);
    });
  });
})();
